const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const OrderSummary = require("./OrderSummary");
const Policies = require("../Policies");
const CheckoutUtil = require("./CheckoutUtil");

const OpsCart = require("../vault/OpsCart");
const ContactInfo = require("./ContactInfo");
const {track} = require("../../core/util/Mixpanel");
const OpsUser = require("../../core/vault/OpsUser");
const styles = require("./styles/CompleteOrder.css");
const StoreUtil = require("../../../shared/StoreUtil");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CheckoutComplete",

		propTypes: {
			cart: PT.object.isRequired,
			setSection: PT.func,
			user: PT.object,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getValidation: function() {
			return OpsCart.getGroupedStepValidation(
				this.props && this.props.cart,
				"review"
			);
		},

		goToSection: function(section) {
			this.props.setSection(section);
		},

		placeOrder: function() {
			track("Order Placed");

			// Throttling done to fix T11411.
			this.doSubmit =
				this.doSubmit ||
				_.throttle(
					() => {
						this.props.dispatch({
							type: AT.PLACE_ORDER_REQUEST,
						});
					},
					500,
					{leading: true, trailing: false}
				);
			this.doSubmit();
		},

		onKeyPress: function(section, evt) {
			if (evt.which === 13) {
				this.goToSection(section);
			}
		},

		renderBox: function(groups, title, section, tabIndex) {
			const allElems = [];
			let singleEl;
			let subtitleClass = styles.subtitle;
			if (groups.length === 1 && groups[0].length === 1) {
				// If there's only one line
				singleEl = <div className={styles.singleLine}>{groups[0][0]}</div>;
				subtitleClass = styles.subtitleSingle;
			} else {
				_.each(groups, (group, i) => {
					if (i > 0) allElems.push(<br key={"break" + i} />);
					_.each(group, elem => {
						allElems.push(elem);
					});
				});
			}

			const editButton = (
				<div
					className={styles.edit}
					onClick={() => this.goToSection(section)}
					tabIndex={tabIndex}
					onKeyPress={evt => this.onKeyPress(section, evt)}
				>
					Edit
				</div>
			);

			return (
				<div className={styles.box} key={section + "Group"}>
					<div className={subtitleClass}>
						{title}
						{singleEl}
						{editButton}
					</div>
					{allElems}
				</div>
			);
		},

		render: function() {
			const {cart, user} = this.props;
			const steps = OpsCart.getAvailableCheckoutSteps(cart);
			const validation = this.getValidation();
			const hasSubscriptionItems = StoreUtil.hasSubscriptionItems(cart.items);
			const isNewAccount = !OpsUser.isLoggedIn(user);
			const shouldShowAccountInfo = isNewAccount || !hasSubscriptionItems;

			const hasAccountStep = _.includes(steps, "account");

			const infoGroups = CheckoutUtil.renderInfoGroupsCart(cart, {
				accountAsGroup: hasAccountStep,
			});

			const boxes = [];
			let acctBox;

			if (this.props.cart.onPaypalFlow) {
				boxes.push(this.renderBox(infoGroups[0], "Info", "paypalinfo"));
			} else {
				let count = 0;
				if (hasAccountStep && shouldShowAccountInfo) {
					acctBox = (
						<div className={styles.content}>
							{this.renderBox(
								infoGroups[count],
								"Account",
								"account",
								count + 1
							)}
						</div>
					);
					count++;
				} else if (hasAccountStep && !shouldShowAccountInfo) {
					count++;
				}
				if (_.includes(steps, "shipping")) {
					boxes.push(
						this.renderBox(infoGroups[count], "Shipping", "shipping", count + 1)
					);
					count++;
					boxes.push(
						this.renderBox(infoGroups[count], "Billing", "billing", count + 1)
					);
				} else {
					boxes.push(
						this.renderBox(infoGroups[count], "Billing", "billing", count + 1)
					);
				}
			}

			return (
				<div className={styles.main}>
					<div className={styles.title}>{"Review Information"}</div>
					<div className={styles.across}>
						<div className={styles.contentContainer}>
							{acctBox}
							<div className={styles.content}>
								{boxes}
								<div className={styles.spaced}>
									<ContactInfo
										contactInfo={OpsCart.getFormSection(cart, "contact")}
										subscribeOnCheckout={cart.subscribeOnCheckout}
										errorFields={validation}
										initialTabIndex={1}
										showParts={["checkbox"]}
										contentOnly={true}
										setCheckedToDefault={!cart.userDidSetSubscribe}
									/>
								</div>
								<Policies
									cart={cart}
									includeTaxExemptInfo={true}
									className={styles.box}
									titleClass={styles.policySubtitle}
								/>
							</div>
						</div>
						<OrderSummary
							{...this.props}
							showItemize={true}
							onContinue={this.placeOrder}
							buttonText="place order"
							tabIndex={3}
							showCaptcha={window.IS_CAPTCHA_ON}
						/>
					</div>
				</div>
			);
		},
	})
);
